module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/tmb_gallery1-153fb23d4c0a4e91cdf57481d19480a6.jpg";